const axios = require('axios')

// Cria a instância do axios com a URL base
const api = axios.create({
  baseURL: 'https://mc-analytics.manyconvert.com',
})

async function getTopCustomers(storeUuid, startDate, endDate) {
  const params = {}
  if (startDate && endDate) {
    params.start_date = startDate
    params.end_date = endDate
  }
  
  const res = await api.get(`/api/stores/${storeUuid}/analytics/top-customers`, { params })
  return res.data
}

async function getBestSellingProducts(storeUuid, startDate, endDate) {
  const params = {}
  if (startDate && endDate) {
    params.start_date = startDate
    params.end_date = endDate
  }
  
  const res = await api.get(`/api/stores/${storeUuid}/analytics/products`, { params })
  return res.data
}

async function getInformationProducts(storeUuid) {
  const res = await api.get(`/api/stores/${storeUuid}/analytics/products/information`)
  return res.data
}

async function getRFM(storeUuid, startDate, endDate) {
  const params = {}
  if (startDate && endDate) {
    params.start_date = startDate
    params.end_date = endDate
  }
  
  const res = await api.get(`/api/stores/${storeUuid}/analytics/rfm`, { params })
  return res.data
}

async function getDemographics(storeUuid, startDate, endDate) {
  const params = {}
  if (startDate && endDate) {
    params.start_date = startDate
    params.end_date = endDate
  }
  
  const res = await api.get(`/api/stores/${storeUuid}/analytics/demographics`, { params })
  return res.data
}

async function getAnalyticCampaigns(storeUuid) {
  const res = await api.get(`/api/stores/${storeUuid}/campaigns/analytics`)
  return res.data
}

async function chatWithIA(storeUuid, question, context = {}) {
  const payload = {
    question,
    context: {
      include_recent_data: true,
      conversation_id: context.conversation_id || storeUuid,
    },
  }
  
  // Apenas inclui o period se for explicitamente fornecido
  // Caso contrário, deixa a IA interpretar do prompt
  if (context.period) {
    payload.context.period = context.period
  }
  
  const res = await api.post(`/api/stores/${storeUuid}/ai/chat`, payload)
  return res.data
}

export {
  getTopCustomers,
  getBestSellingProducts,
  getInformationProducts,
  getRFM,
  getDemographics,
  getAnalyticCampaigns,
  chatWithIA,
}
